import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M19 4H14.92V2H19C20.1 2 21 2.9 21 4V20C21 21.1 20.1 22 19 22H14.99V20H19V4ZM15.96 12L9.72 5.75L8.3 7.17L12.11 10.99H3V13H12.11L8.3 16.82L9.72 18.24L15.96 11.99V12Z" fill={ fill || 'currentColor' } />
    </svg>
);
